import { useMsal } from "@azure/msal-react";
import { Stack } from "@mui/material";
import React, { useEffect, useState } from "react";

// import Table from "@mui/material/Table";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserLauchMailresponse } from "../Redux/Approver";
import MyContentMailGeneration from "./MyContentMailGeneration";
import "./MyContentPage.css";
import MyContentTabs from "./MyContentTabs";

const MyContentPage = () => {
 //const [launchMails, setLaunchMails] = useState("");
 const [statusName, setStatusName] = useState("All");
 const [searchedText, setSearchedText] = useState("");
 const [filteredLaunchMails, setFilteredLaunchMails] = useState([]);
 const [page, setPage] = useState(0);
 const [rowsPerPage, setRowsPerPage] = useState(10);
 const [selectedMail, setSelectedMail] = useState("");
 const [uniqueID, setUniqueID] = useState("");
 const [activeScreen, setActiveScreen] = useState("default");
 const [modalContent, setModalContent] = useState({});
 const [openModal, setOpenModal] = useState(false);
 const [modalRecord, setModalRecord] = useState();
 const [status, setStatus] = useState();
 const [program, setProgram] = useState("");
 const [type, setType] = useState("");
 const [campaignId, setaCmpaignId] = useState();

 const [filteredInfo, setFilteredInfo] = useState({});
 const [sortedInfo, setSortedInfo] = useState({});
 const { instance } = useMsal();
 const activeAccount = instance.getActiveAccount();
 const [user, setUser] = useState(null);
 const launchMails = useSelector((state) => state.approver.userLaunchMails);

 const [activeButton, setActiveButton] = useState(1);

 const handleOpen = (record) => {
  setOpenModal(true);
  setModalRecord(record);
  // setModalContent(clickedCourseDetail[0]);
 };
 useEffect(() => {
  if (activeAccount) {
   setUser(activeAccount.idTokenClaims.enterpriseID);
  }
 }, [activeAccount]);
 const handleClose = () => {
  setOpenModal(false);
 };
 useEffect(() => {
  dispatch(fetchUserLauchMailresponse(user));
 }, [user]);
 const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
 };

 const columns = [
  {
   title: "SI#",
   dataIndex: "s.no",
   key: "s.no",
   render: (value, record) => record.sno,
  },
  {
   title: "Content Type",
   dataIndex: "subcategory",
   key: "subcategory",
   filters: formFilters("subcategory"),
   filteredValue: filteredInfo.subcategory || null,
   onFilter: (value, record) => record.subcategory == value,
   ellipsis: true,
  },
  {
   title: "Sub-Type",
   dataIndex: "mailtype",
   key: "mailtype",
   filters: formFilters("mailtype"),
   filteredValue: filteredInfo.mailtype || null,
   onFilter: (value, record) => record.mailtype == value,
   ellipsis: true,
  },
  {
   title: "Program Name",
   dataIndex: "programname",
   key: "programname",
  },
  {
   title: "View Content",
   dataIndex: "contentlink",
   render: (_, record) => (
    <p
     onClick={() =>
      handleDispalyContent(
       record.template,
       record.uniqueID,
       record.isApproved,
       record.programname,
       record.mailtype,
       record.campaignId
      )
     }
     style={{
      textDecoration: "underline",
      color: "blue",
      cursor: "pointer",
     }}
    >
     View Content
    </p>
   ),
   key: "contentlink",
  },
  {
   title: "Date Created",
   dataIndex: "sendDate",
   key: "sendDate",
   filters: formFilters("sendDate"),
   filteredValue: filteredInfo.sendDate || null,
   onFilter: (value, record) => record.sendDate == value,
   sorter: (a, b) => {
    var aa = a.sendDate?.split("/").reverse().join();
    var bb = b.sendDate?.split("/").reverse().join();

    return aa < bb ? -1 : aa > bb ? 1 : 0;
   },
   //   sortOrder: sortedInfo.columnKey === "sendDate" ? sortedInfo.order : null,
   defaultSortOrder: "descend",
   ellipsis: true,
  },
  {
   title: "Status",
   dataIndex: "isApproved",
   key: "isApproved",
   ellipsis: true,
   render: (_, record) => (
    <p>
     {" "}
     {record.isApproved == 1
      ? "Approved"
      : record.isApproved == 0
      ? "Not Applicable"
      : record.isApproved == 2
      ? "On hold"
      : "Waiting for Approval"}
    </p>
   ),
  },
  {
   title: "Details",
   render: (_, record) => (
    <img
     onClick={() => handleOpen(record)}
     style={{ width: "15px", cursor: "pointer" }}
     src={process.env.PUBLIC_URL + "/Images/desc_icon.png"}
    ></img>
   ),
  },
 ];
 const dispatch = useDispatch();

 const handleChange = (pagination, filters, sorter) => {
  setFilteredInfo(filters);
  setSortedInfo(sorter);
 };
 const clearFilters = () => {
  setFilteredInfo({});
 };
 const clearAll = () => {
  setFilteredInfo({});
  setSortedInfo({});
 };

 const handleChangePage = (event, newPage) => {
  setPage(newPage);
 };

 function formFilters(x) {
  return Array.from(new Set(launchMails?.map((element) => element[x])))?.map((item) => {
   return {
    text: item,
    value: item,
   };
  });
 }

 const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(+event.target.value);
  setPage(0);
 };
 const handleDispalyContent = (value, uniqueID, status, program, type, campaignId) => {
  setSelectedMail(value);
  setUniqueID(uniqueID);
  setActiveScreen("contentscreen");
  setStatus(status);
  setProgram(program);
  setType(type);
  setaCmpaignId(campaignId);
 };
 //  useEffect(() => {
 //   dispatch(fetchUserLauchMailresponse(user));
 //  }, []);

 useEffect(() => {
  setFilteredLaunchMails(
   launchMails?.filter((value) => {
    return (
     value?.category?.toLowerCase()?.includes(searchedText.toLowerCase()) ||
     value?.mailtype?.toLowerCase()?.includes(searchedText.toLowerCase()) ||
     value?.programname?.toLowerCase()?.includes(searchedText.toLowerCase()) ||
     (value?.user?.toLowerCase()?.includes(searchedText.toLowerCase()) &&
      (statusName == "Approved" ? value.isApproved == 1 : value.isApproved == -1))
    );
   })
  );
 }, [searchedText, launchMails]);

 const handleCategoryChange = (val) => {
  setStatusName(val);
  if (searchedText == "") {
   val == "Approved"
    ? setFilteredLaunchMails(
       launchMails?.filter((value) => {
        return value?.isApproved == 1;
       })
      )
    : val == "Not Applicable"
    ? setFilteredLaunchMails(
       launchMails?.filter((value) => {
        return value?.isApproved == 0;
       })
      )
    : val == "On Hold"
    ? setFilteredLaunchMails(
       launchMails?.filter((value) => {
        return value?.isApproved == 2;
       })
      )
    : val == "Waiting for Approval"
    ? setFilteredLaunchMails(
       launchMails?.filter((value) => {
        return value?.isApproved !== -1;
       })
      )
    : setFilteredLaunchMails(launchMails);
  } else {
   val == "Approved"
    ? setFilteredLaunchMails(
       launchMails?.filter((value) => {
        return (
         value?.isApproved == 1 &&
         (value?.category?.toLowerCase()?.includes(searchedText.toLowerCase()) ||
          value?.mailtype?.toLowerCase()?.includes(searchedText.toLowerCase()) ||
          value?.programname?.toLowerCase()?.includes(searchedText.toLowerCase()) ||
          value?.user?.toLowerCase()?.includes(searchedText.toLowerCase()))
        );
       })
      )
    : val == "Waiting for Approval"
    ? setFilteredLaunchMails(
       launchMails?.filter((value) => {
        return (
         value?.isApproved == -1 &&
         (value?.category?.toLowerCase()?.includes(searchedText.toLowerCase()) ||
          value?.mailtype?.toLowerCase()?.includes(searchedText.toLowerCase()) ||
          value?.programname?.toLowerCase()?.includes(searchedText.toLowerCase()) ||
          value?.user?.toLowerCase()?.includes(searchedText.toLowerCase()))
        );
       })
      )
    : val == "On Hold"
    ? setFilteredLaunchMails(
       launchMails?.filter((value) => {
        return (
         value?.isApproved == 2 &&
         (value?.category?.toLowerCase()?.includes(searchedText.toLowerCase()) ||
          value?.mailtype?.toLowerCase()?.includes(searchedText.toLowerCase()) ||
          value?.programname?.toLowerCase()?.includes(searchedText.toLowerCase()) ||
          value?.user?.toLowerCase()?.includes(searchedText.toLowerCase()))
        );
       })
      )
    : val == "Not Applicable"
    ? setFilteredLaunchMails(
       launchMails?.filter((value) => {
        return (
         value?.isApproved == 0 &&
         (value?.category?.toLowerCase()?.includes(searchedText.toLowerCase()) ||
          value?.mailtype?.toLowerCase()?.includes(searchedText.toLowerCase()) ||
          value?.programname?.toLowerCase()?.includes(searchedText.toLowerCase()) ||
          value?.user?.toLowerCase()?.includes(searchedText.toLowerCase()))
        );
       })
      )
    : setFilteredLaunchMails(
       launchMails?.filter((value) => {
        return (
         value?.category?.toLowerCase()?.includes(searchedText.toLowerCase()) ||
         value?.mailtype?.toLowerCase()?.includes(searchedText.toLowerCase()) ||
         value?.programname?.toLowerCase()?.includes(searchedText.toLowerCase()) ||
         value?.user?.toLowerCase()?.includes(searchedText.toLowerCase())
        );
       })
      );
  }
 };

 return (
  <>
   {activeScreen == "default" && (
    <Stack sx={{ margin: "0px 0px 40px 0px" }}>
     <Stack>
      <div className="ant-table-custom-container">
       <MyContentTabs />
      </div>
      <Modal
       hideBackdrop
       open={openModal}
       onClose={handleClose}
       aria-labelledby="child-modal-title"
       closeAfterTransition
       aria-describedby="child-modal-description"
       className="modal-container"
      >
       <Box className="model">
        <div className="model_heading">
         <h5 className="paramodel">Details</h5>
         <span className="close_btn_model" onClick={handleClose} tabIndex={0}>
          Close
         </span>
        </div>
        <hr />
        <div className="program-modal-details">
         <div className="program-details-wrap">
          <p className="program-details-header">Category: </p>
          <p className="program-details-value">{modalRecord?.category}</p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">Program Name: </p>
          <p className="program-details-value">{modalRecord?.programname}</p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">Content Type: </p>
          <p className="program-details-value">{modalRecord?.subcategory}</p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">Content Sub-Type: </p>
          <p className="program-details-value">{modalRecord?.mailtype}</p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">Date Created: </p>
          <p className="program-details-value">{modalRecord?.sendDate}</p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">Status: </p>
          <p className="program-details-value">
           {modalRecord?.isApproved == 1 ? "Approved" : "Waiting for Approval"}
          </p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">Additional Notes: </p>
          <p className="program-details-value"></p>
         </div>
        </div>
       </Box>
      </Modal>
     </Stack>
    </Stack>
   )}
   {activeScreen != "default" && (
    <MyContentMailGeneration
     selectedMail={selectedMail}
     setSelectedMail={setSelectedMail}
     uniqueID={uniqueID}
     status={status}
     setActiveScreen={setActiveScreen}
     program={program}
     type={type}
     campaignId={campaignId}
    />
   )}
  </>
 );
};

export default MyContentPage;
